import { useEffect, useState } from "react";

export const useResizeObserver = (targetRef) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!targetRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        if (targetRef.current) {
          setSize({
            width: targetRef.current.offsetWidth,
            height: targetRef.current.offsetHeight
          });
        }
      });
    });

    resizeObserver.observe(targetRef.current);

    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line
  }, [targetRef?.current]);

  return size;
};
